let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1vgvL")).then(() => parcelRequire('3Ehcx'));